enum RecipientDetailsActionType {
    RECIPIENT_DETAILS_SHOW_SHIMMER = "RECIPIENT_DETAILS_SHOW_SHIMMER",
    RECIPIENT_DETAILS_LOAD_DATA = "RECIPIENT_DETAILS_LOAD_DATA",
    RECIPIENT_DETAILS_DISPLAY_ERROR = "RECIPIENT_DETAILS_DISPLAY_ERROR",
}

export default RecipientDetailsActionType;